import { RouterProvider } from "react-router-dom";
import router from "./router";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./config/query";
import Backdrop from "./components/base/backdrop";
import { useUser } from "./context/user";
import useHydrateApp from "./hooks/auth/useHydrateApp";
import { Toaster } from "sonner";

const App: React.FC = () => {
  const globalLoading = useUser((state) => state.globalLoading);

  useHydrateApp();

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Backdrop loading={globalLoading} />
      <Toaster richColors />
    </QueryClientProvider>
  );
};

export default App;
